import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface KbSearchState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const KbSearchContext = createContext<KbSearchState | null>(null);

export function KbSearchStateProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  return (
    <KbSearchContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </KbSearchContext.Provider>
  );
}

export function useKbSearchState() {
  const ctx = useContext(KbSearchContext);
  if (!ctx) throw new Error("useKbSearchState must be used within KbSearchStateProvider");
  return ctx;
}
